module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-cloud-89279df85810566bed32da4b8593953a.svg";